import { FunctionComponent } from 'preact';
import { css } from '../../../../common/styles/styles.utils';
import { Icon } from '../../../../common/components/icon/icon';

interface GalleryArrowsVariablesProps {
  wrapperStyle: any;
  arrowStyle: { [key: string]: any };
  onClick: (event?: Event) => void;
  icon: SVGElement;
  id: string;
  ariaLabel: string;
}

export const GalleryArrows: FunctionComponent<GalleryArrowsVariablesProps> = props => {
  const { wrapperStyle, arrowStyle, onClick, icon, id, ariaLabel } = props;

  return (
    <div style={css(wrapperStyle)}>
      <Icon
        icon={icon}
        style={arrowStyle}
        onClick={onClick}
        id={id}
        ariaLabel={ariaLabel}
      />
    </div>
  );
};
